var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChallengeCrown = function SvgChallengeCrown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-13.9%",
    y: "-17.9%",
    width: "127.8%",
    height: "135.7%",
    filterUnits: "objectBoundingBox",
    id: "challengeCrown_svg__a"
  }, /*#__PURE__*/React.createElement("feOffset", {
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0",
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#challengeCrown_svg__a)",
    transform: "translate(2 2)",
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 9,
    cy: 3.702,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 9,
    cy: 9.642,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 16.709,
    cy: 6.545,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 1.29,
    cy: 6.545,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 13.194,
    cy: 5.74,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: 4.805,
    cy: 5.74,
    r: 1
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FED030",
    x: 0.362,
    y: 12.264,
    width: 17.275,
    height: 1.736,
    rx: 0.868
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.822 12.264h-.543c.45 0 .815.389.815.868 0 .48-.365.868-.815.868h.543c.45 0 .815-.389.815-.868s-.365-.868-.815-.868Z",
    fill: "#F8BE32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1.367 12.264-.68-4.018L0 4.88l2.454 1.099-.008.014a.97.97 0 0 0 .06 1.274c.336.34.863.34 1.199 0a.97.97 0 0 0 .06-1.274l-.008-.014.487-2.986 1.65 2.523c-.052.17-.069.349-.048.526.072.603.565.915.623.95.44.266.984.239 1.4-.068.569-.429.547-1.166.542-1.246A1.594 1.594 0 0 0 7.447 4.3L8.99 0h.02l1.541 4.3c-.558.242-.937.78-.964 1.377-.004.08-.026.817.543 1.246.415.307.959.333 1.399.068.058-.035.551-.347.624-.95.02-.177.003-.357-.049-.526l1.65-2.523.487 2.986-.008.013a.97.97 0 0 0 .06 1.274c.336.34.863.34 1.198 0a.97.97 0 0 0 .06-1.274l-.006-.013 2.454-1.1-.688 3.37-.68 4.018-15.264-.002Z",
    fill: "#FED030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.677 4.423a1.619 1.619 0 0 0-.18-.26l-.049.138c.08.034.156.075.229.122Zm6.022.976-.008.014a.971.971 0 0 0-.18.847.904.904 0 0 0 .559.633.972.972 0 0 1 .164-.901l.007-.014-.486-2.986-.36.55.304 1.857Zm-3.691-1.677c-.559.241-.937.78-.965 1.376-.003.08-.025.817.544 1.246.05.038.102.071.156.1a1.718 1.718 0 0 1-.157-.767A1.594 1.594 0 0 1 10.55 4.3L9.01 0h-.02l-.158.444 1.176 3.278Z",
    fill: "#F8BE32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.271 5.204-.502 2.464-.573 3.384c-.062.367-.363.634-.714.634H1.27l.098.578h15.265l.68-4.018.688-3.37-.729.328Zm-11.92-.267c-.052.169-.069.348-.049.525.073.603.566.916.624.951l.036.02a1.205 1.205 0 0 1-.117-.392 1.288 1.288 0 0 1 .048-.526L4.244 2.992l-.032.202L5.35 4.937ZM1.7 6.14c.045.348.27.639.582.752a.972.972 0 0 1 .163-.901l.008-.014-.698-.312a.981.981 0 0 0-.055.475Z",
    fill: "#F8BE32"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#EB304A",
    cx: 9,
    cy: 9.623,
    rx: 1.177,
    ry: 1.253
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 8.37a1.11 1.11 0 0 0-.272.033c.53.134.905.639.905 1.22 0 .58-.374 1.085-.905 1.22.441.11.903-.057 1.188-.433a1.32 1.32 0 0 0 .146-1.328A1.173 1.173 0 0 0 9 8.369Z",
    fill: "#E4222E"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB304A",
    cx: 15.193,
    cy: 9.623,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.193 9.044a.51.51 0 0 0-.117.014.572.572 0 0 1 .425.565.572.572 0 0 1-.425.564.526.526 0 0 0 .544-.206.61.61 0 0 0 .063-.611.541.541 0 0 0-.49-.326Z",
    fill: "#E4222E"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB304A",
    cx: 2.807,
    cy: 9.623,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CABE1",
    d: "m5.74 10.926-.935-1.303.935-1.304.935 1.304z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.74 8.32-.271.377.495.69c.1.139.1.33 0 .469l-.495.692.271.379.935-1.304-.935-1.304Z",
    fill: "#199AD5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1CABE1",
    d: "m12.26 10.926-.936-1.303.935-1.304.935 1.304z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.26 8.32-.273.377.496.69c.099.139.099.33 0 .469l-.496.692.272.379.935-1.304-.935-1.304Z",
    fill: "#199AD5"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB304A",
    cx: 9,
    cy: 3.702,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    cx: 9,
    cy: 9.642,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB304A",
    cx: 16.709,
    cy: 6.545,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#EB304A",
    cx: 1.29,
    cy: 6.545,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1CABE1",
    cx: 13.194,
    cy: 5.74,
    r: 1
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#1CABE1",
    cx: 4.805,
    cy: 5.74,
    r: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.807 9.044a.51.51 0 0 0-.117.014.572.572 0 0 1 .425.565.572.572 0 0 1-.425.564.526.526 0 0 0 .544-.206.61.61 0 0 0 .063-.611.541.541 0 0 0-.49-.326Z",
    fill: "#E4222E"
  }))));
};
export default SvgChallengeCrown;